import React from "react";

const PlatinumEllipse = ({
  width = 53,
  height = 52,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 53 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="52" r="52" fill="#B07D26" />
    </svg>
  );
};

export default PlatinumEllipse;
